import { useCallback } from 'react';
import ConnectionQualityService from 'utils/services/connectionQuality';
import { CONNECTION_STATES } from 'utils/services/connectionQuality/constants';
import { notification } from 'utils/services';

const service = new ConnectionQualityService();

const useConnectionCheck = () => {
  const checkConnection = useCallback(async () => {
    if (!navigator.onLine) {
      notification.error('You are offline. Some features may be unavailable.');
      return CONNECTION_STATES.OFFLINE;
    }

    const result = await service.checkNow();

    if (result.state === CONNECTION_STATES.SLOW) {
      notification.warning(
        'Your internet connection is poor. This submission may fail, especially when uploading photos and/or documents. Try moving to an area with better signal, switching to a different network, or restarting your connection and trying again.',
        null,
        { autoClose: 15000 },
      );
    } else if (result.state === CONNECTION_STATES.UNSTABLE) {
      notification.error(
        'Your internet connection is poor. This submission may fail, especially when uploading photos and/or documents. Try moving to an area with better signal, switching to a different network, or restarting your connection and trying again',
        null,
        { autoClose: 15000 },
      );
    }

    return result.state;
  }, []);

  return checkConnection;
};

export default useConnectionCheck;
